import intersection from "lodash/intersection"
import sortBy from "lodash/sortBy"
import { useTranslation } from "react-i18next"
import { useQueryState } from "@/hooks"
import { useTeams } from "@/hooks/useTeams"
import type { TUser } from "@/types"
import { MultiFilter } from "./MultiFilter"

const filterName = "dpt"

export function TeamFilter({ only }: { only?: string[] }) {
  const { t } = useTranslation()
  const { teams, isPending } = useTeams()
  const items = sortBy(
    teams
      ?.filter((team) => !only || only.length == 0 || only.includes(team.id))
      .map((team) => ({ value: team.id, label: team.name })) || [],
    ["label"],
  )
  const [value, setValue] = useQueryState<string[]>(filterName, { multi: true })

  return (
    <MultiFilter
      items={items}
      value={value ?? []}
      loading={isPending}
      label={t("Filter by department")}
      setValue={(value) => setValue(value?.length > 0 ? value : undefined)}
    />
  )
}

TeamFilter.useValue = () => {
  const [value] = useQueryState<string[]>(filterName, { multi: true })
  return value ?? []
}

TeamFilter.filterName = filterName

TeamFilter.useFilter = (users: TUser[]) => {
  const teams = TeamFilter.useValue()
  return teams.length == 0 ? users : users.filter((u) => intersection(u.team_ids, teams).length > 0)
}
